module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tags.length > 0) ? _c('div', {
    staticClass: "mltags"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mldata-details"
  }, [(typeof _vm.record.mldata.relevance !== 'undefined' && _vm.record.mldata.relevance !== null) ? _c('p', [_c('strong', [_vm._v("Relevance")]), _vm._v(":\n        " + _vm._s(_vm._f("round")(_vm.record.mldata.relevance)) + "\n        "), (_vm.record.mldata.keyword) ? _c('span', [_vm._v("\n          (" + _vm._s(_vm.record.mldata.keyword) + ")\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (typeof _vm.record.mldata.consistency !== 'undefined' && _vm.record.mldata.consistency !== null) ? _c('p', [_c('strong', [_vm._v("Consistency")]), _vm._v(": " + _vm._s(_vm._f("round")(_vm.record.mldata.consistency)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "mltags-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.manualTags), function(tag, mIndex) {
    return _c('tr', {
      key: tag.category + mIndex
    }, [_c('td', [_vm._v(_vm._s(tag.category))]), _vm._v(" "), (tag.weight) ? _c('td', [_vm._v(_vm._s(Math.round(tag.weight * 10000000) / 1000))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(tag.frames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(tag.accuracy)))])])
  }), _vm._v(" "), _vm._l((_vm.mlTags), function(tag, mlIndex) {
    return _c('tr', {
      key: mlIndex
    }, [_c('td', [_vm._v(_vm._s(tag.category))]), _vm._v(" "), (tag.weight) ? _c('td', [_vm._v(_vm._s(Math.round(tag.weight * 10000000) / 1000))]) : _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(tag.frames))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("round")(tag.accuracy)))])])
  })], 2)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tags-toggle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-tags"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Weight")]), _vm._v(" "), _c('th', [_vm._v("# Frames")]), _vm._v(" "), _c('th', [_vm._v("Accuracy")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fc899d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/MLTags.vue
// module id = 1018
// module chunks = 1